var ChapterDoc, MDA_HANDOUT, MDA_TOPIC, MdaTopicDoc, MdaTopicRootDoc, MiniDSRootDoc, W, callMethod, convertRowsToArray, etdHelper, flatPluckCompact, getChapterIds, mdaUtils, mediator, sequence, unfold, _ref, _ref1,
  __slice = [].slice;

ChapterDoc = require('lib/db_docs/document_sections_v2_chapter_doc');

_ref = require('lib/app_utils'), convertRowsToArray = _ref.convertRowsToArray, flatPluckCompact = _ref.flatPluckCompact;

callMethod = require('base/lib/utils').callMethod;

etdHelper = require('lib/etd_helper');

_ref1 = require('lib/db_docs/doc_types'), MDA_HANDOUT = _ref1.MDA_HANDOUT, MDA_TOPIC = _ref1.MDA_TOPIC;

MdaTopicDoc = require('lib/db_docs/mda_topic_doc');

MdaTopicRootDoc = require('lib/db_docs/mda_topic_root_doc');

MiniDSRootDoc = require('lib/db_docs/mini_ds_root_doc');

mediator = require('mediator');

sequence = require('when/sequence');

unfold = require('when/unfold');

W = require('when/when');

getChapterIds = function(_arg) {
  var chapterDocs, rows;
  rows = _arg.rows;
  chapterDocs = _.pluck(rows, 'doc');
  return W.all(_.reduce(chapterDocs, function(acc, doc) {
    return acc.concat(W.resolve([doc._id].concat(__slice.call(doc.sections), __slice.call(doc.subchapters))), ChapterDoc.at(mediator.project.id, doc._id).fetch(doc.subchapters).then(getChapterIds));
  }, []));
};

module.exports = mdaUtils = {
  HEALTH_ADVISOR_WORKSPACE_ID: 'o_health_advisor_0',
  MASTER_PROJECT_ID: 'p_mda_master',
  TOPIC_STATUSES: ['editSetup', 'medicalEditing', 'mar', 'copyEditing', 'medicalCoding', 'finalEditingCheck', 'durationSetup', 'durationReview1', 'durationReview2', 'durationReview3', 'durationEditing', 'finalDurationCheck', 'doneDR', 'done'],
  getChapterAndSectionIds: function(projectId, rootDoc) {
    var handler, predicate, seed, _ref2, _ref3;
    handler = function(_arg) {
      var chapterId, chapterIds, queue, sectionIds;
      chapterIds = _arg.chapterIds, queue = _arg.queue, sectionIds = _arg.sectionIds;
      chapterId = queue.pop();
      return mediator.services.storePersistenceAdapter.fetch(projectId, chapterId)["catch"](function(err) {
        var newSeed;
        if (err.status !== 404) {
          throw err;
        }
        newSeed = {
          chapterIds: chapterIds,
          queue: queue,
          sectionIds: sectionIds
        };
        return [newSeed, newSeed];
      }).then(function(chapter) {
        var newSeed, _ref2, _ref3, _ref4;
        chapterIds = _.union([], chapterIds, (_ref2 = chapter.subchapters) != null ? _ref2 : []);
        sectionIds = _.union([], sectionIds, (_ref3 = chapter.sections) != null ? _ref3 : []);
        queue = _.union([], queue, (_ref4 = chapter.subchapters) != null ? _ref4 : []);
        newSeed = {
          chapterIds: chapterIds,
          queue: queue,
          sectionIds: sectionIds
        };
        return [newSeed, newSeed];
      });
    };
    predicate = function(_arg) {
      var queue;
      queue = _arg.queue;
      return queue.length === 0;
    };
    seed = {
      chapterIds: Array.from((_ref2 = rootDoc.chaptersOrder) != null ? _ref2 : []),
      queue: Array.from((_ref3 = rootDoc.chaptersOrder) != null ? _ref3 : []),
      sectionIds: []
    };
    return unfold(handler, predicate, _.noop, seed);
  },
  deleteRelatedDocs: function(mainDocument) {
    var Doc, docType, projectId, rootId, _ref2;
    rootId = (_ref2 = mainDocument.topicRootId) != null ? _ref2 : mainDocument.docRootId;
    docType = mainDocument.docType;
    if (_.isEmpty(rootId)) {
      return W.resolve([]);
    }
    projectId = mediator.project.id;
    Doc = (function() {
      switch (docType) {
        case MDA_HANDOUT:
          return MiniDSRootDoc;
        case MDA_TOPIC:
          return MdaTopicRootDoc;
        default:
          throw new Error("Unknown docType " + docType);
      }
    })();
    return Doc.at(projectId, rootId).fetch().then(function(rootDoc) {
      return ChapterDoc.at(projectId).fetch(rootDoc.chaptersOrder).then(getChapterIds).then(function(chaptersAndSectionIds) {
        return etdHelper.removeRecommendationTable(_.unique(_.compact(_.flatten(chaptersAndSectionIds.concat(rootId)))));
      }).then(function(deletedDocs) {
        var removeFromTopicPromise, _ref3;
        removeFromTopicPromise = docType === MDA_HANDOUT ? mdaUtils.removeHandoutFromTopic((_ref3 = mainDocument.options) != null ? _ref3.parentTopicId : void 0, mainDocument._id) : W.resolve();
        return removeFromTopicPromise.then(function() {
          return deletedDocs;
        });
      });
    });
  },
  filterTopicsByRoleAndStatus: function(topics, statuses, statusFilter) {
    var isAdmin, userAccessRights, userEmail;
    userEmail = mediator.user.getEmail().toLowerCase();
    userAccessRights = mediator.user.getAccessRights();
    isAdmin = _.contains(mediator.user.getAccessRights(), 'admin');
    topics = statusFilter === 'all' ? topics : topics.filter(function(topic) {
      var status;
      status = statuses.getIn([topic.get('_id'), 'mdaTopicsStatus', 'status'], null);
      return status === statusFilter;
    });
    return topics.filter(function(topic) {
      var editor, editorEmail, mab1, mab1Email, mab2, mab2Email, mab3, mab3Email, mar, marEmail, status, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
      status = statuses.getIn([topic.get('_id'), 'mdaTopicsStatus', 'status'], null);
      _ref2 = topic.get('members', Immutable.Map()).toJS(), editor = _ref2.editor, mab1 = _ref2.mab1, mab2 = _ref2.mab2, mab3 = _ref2.mab3, mar = _ref2.mar;
      marEmail = (mar != null ? (_ref3 = mar.email) != null ? _ref3.toLowerCase() : void 0 : void 0) || '';
      editorEmail = (editor != null ? (_ref4 = editor.email) != null ? _ref4.toLowerCase() : void 0 : void 0) || '';
      mab1Email = (mab1 != null ? (_ref5 = mab1.email) != null ? _ref5.toLowerCase() : void 0 : void 0) || '';
      mab2Email = (mab2 != null ? (_ref6 = mab2.email) != null ? _ref6.toLowerCase() : void 0 : void 0) || '';
      mab3Email = (mab3 != null ? (_ref7 = mab3.email) != null ? _ref7.toLowerCase() : void 0 : void 0) || '';
      return isAdmin || ((status === 'mar' && marEmail === userEmail && _.contains(userAccessRights, 'mda_mar')) || (status === 'copyEditing' && editorEmail === userEmail && _.contains(userAccessRights, 'mda_editor')) || (status === 'durationReview1' && userEmail === mab1Email) || (status === 'durationReview2' && userEmail === mab2Email) || (status === 'durationReview3' && userEmail === mab3Email) || (_.contains(userAccessRights, 'mda_mab') && ((status === 'durationReview1' && _.isEmpty(mab1Email)) || (status === 'durationReview2' && _.isEmpty(mab2Email) && mab1Email !== userEmail) || (status === 'durationReview3' && _.isEmpty(mab3Email) && (userEmail !== mab1Email && userEmail !== mab2Email)))));
    });
  },
  getDocIds: function(topicsToUse) {
    var handoutsIds, rootDocsIds, tablesIds, topicsIds;
    topicsIds = _.chain(topicsToUse).pluck('_id').uniq().value();
    tablesIds = _.chain(topicsToUse).pluck('insertedTables').compact().flatten().uniq().value();
    rootDocsIds = _.chain(topicsToUse).pluck('topicRootId').compact().uniq().value();
    handoutsIds = _.chain(topicsToUse).pluck('handouts').compact().flatten().uniq().value();
    return {
      rootDocsIds: rootDocsIds,
      tablesIds: tablesIds,
      topicsIds: topicsIds,
      handoutsIds: handoutsIds
    };
  },
  fetchRootDocsForHandouts: function(projectId, handoutsIds) {
    if (_.isEmpty(handoutsIds)) {
      return W.resolve([]);
    }
    return mediator.services.storePersistenceAdapter.fetch(projectId, handoutsIds).then(function(_arg) {
      var rows;
      rows = _arg.rows;
      return _.chain(rows).pluck('doc').compact().pluck('docRootId').uniq().value();
    });
  },
  getRelatedDocIdsForRootDoc: function(projectId, rootDocIds) {
    return mediator.services.storePersistenceAdapter.fetch(projectId, rootDocIds).then(function(_arg) {
      var rootDocs, rows;
      rows = _arg.rows;
      rootDocs = convertRowsToArray(rows);
      return sequence(_.map(rootDocs, function(rootDoc) {
        return function() {
          return mdaUtils.getChapterAndSectionIds(projectId, rootDoc);
        };
      }));
    }).then(function(results) {
      var chapterIds, sectionIds;
      chapterIds = flatPluckCompact(results, 'chapterIds');
      sectionIds = flatPluckCompact(results, 'sectionIds');
      return _.uniq(_.union([], rootDocIds, chapterIds, sectionIds));
    });
  },
  fetchIdsForTopics: function(projectId, topics, withHandoutIds) {
    var handoutsDocIdsPromise, handoutsIds, rootDocsIds, tablesIds, topicsIds, _ref2;
    _ref2 = mdaUtils.getDocIds(topics), rootDocsIds = _ref2.rootDocsIds, tablesIds = _ref2.tablesIds, topicsIds = _ref2.topicsIds, handoutsIds = _ref2.handoutsIds;
    handoutsDocIdsPromise = withHandoutIds ? mdaUtils.getAllDocIdsForHandouts(projectId, handoutsIds) : W.resolve([]);
    return W.all([mdaUtils.getRelatedDocIdsForRootDoc(projectId, rootDocsIds), handoutsDocIdsPromise]).then(function(_arg) {
      var handoutDocs, relatedDocIds;
      relatedDocIds = _arg[0], handoutDocs = _arg[1];
      return _.uniq(_.union([], relatedDocIds.concat(handoutDocs), tablesIds, topicsIds));
    });
  },
  getAllDocIdsForHandouts: function(projectId, handoutIds) {
    if (_.isEmpty(handoutIds)) {
      return W.resolve([]);
    }
    return mdaUtils.fetchRootDocsForHandouts(projectId, handoutIds).then(function(rootDocIds) {
      return mdaUtils.getRelatedDocIdsForRootDoc(projectId, rootDocIds);
    }).then(function(results) {
      return _.uniq(_.union([], results, handoutIds));
    });
  },
  removeHandoutFromTopic: function(topicId, handoutId) {
    if (!topicId) {
      W.resolve();
    }
    return MdaTopicDoc.at(mediator.project.id, topicId).updateAsInstance(callMethod('removeHandout', handoutId))["catch"](function(err) {
      return errorHandlerWithMsg(err, $.t('mda:topics.remove_handout_error'));
    });
  }
};
